// slideshowCentral
// version 0.1.1
// requires JQuery

/*

slideshowCentral will take an array of slides and populate a div with a
group of sliding images (divs with backgrounds), controlled by left and right
arrows below them.

Current version should be placed above a dark-colored background, like black.
A version that works on a light background is planned.

Step 1: Link the CSS.
    <link type="text/css" rel="stylesheet" href="/style/slideshowCentral.css">

Step 2: Load the JS.
    <script src="/js/slideshowCentral.js"></script>

Step 3: Create your array of slides.
    Each slide should be an object of three strings:
        - id: this is the element id of the slide to show
        - title: brief title of the slide (optional)
        - caption: description/caption of the slide (optional) and can include
            html tags, like <span>.

    var mySlides = [
        {
            id: "slide-foo",
            title: "Foo",
            caption: "Lorem ipsum dolor sit amet, consectetur adipiscing elit."
        },{
            id: "slide-bar",
            title: "Bar",
            caption: "Proin et venenatis elit, at sodales mi."
        },{
            id: "slide-foobar",
            title: "Foo Bar",
            caption: "Sed felis elit, vestibulum vitae luctus vitae, hendrerit sodales neque."
        }
    ]

Step 4: Use the IDs to assign proper backgrounds in your CSS/SASS/LESS.
    #slide-foo {
        height: 300px;
        width: 400px;
        background-size: 400px 300px;
        background-repeat: no-repeat;
        background-position: center;
        background-image: URL('/imgs/foo.png');

        @media only screen and (min-device-pixel-ratio: 1.3),
            only screen and (min-resolution: 120dpi) {
                background-image: URL("/imgs/foo@2x.png");
        }
    }

Step 5: Create the target div.
    <div id="my-slideshow"></div>

Step 6: Init the JS in a script towards the bottom of the page (past the target
    div) with slideshowCentral.init("divID", slideArray).

    It is recommended to not load slideshows on devices whose screen is smaller
    than 700 pisxels:

    if (screen.width > 700) slideshowCentral.init("my-slideshow", mySlides);

Step 7 (Optional): style div.slideshow-title and div.slidshow-caption to
    override default styling.

    div.slideshow-title {
        font-size: 18px;
        color: blue;
    }

*/

var slideshowCentral = {
    currSlide: {},
    slides: {},
    goToSlide: function(slideshowID, slideIndex) {
        this.currSlide[slideshowID] = slideIndex;
        $("#" + slideshowID + " .slideshow-wrapper").animate({
            left: slideshowCentral.currPos(slideshowID)
        });
        $("#" + slideshowID + " .slideshow-slide").removeClass("current-slide");
        $($("#" + slideshowID + " .slideshow-slide")[slideIndex]).addClass("current-slide");
        $("#" + slideshowID + " .slideshow-button").removeClass("current-button");
        $($("#" + slideshowID + " .slideshow-button")[slideIndex]).addClass("current-button");
        $("#" + slideshowID + " .slideshow-title").html(this.slides[slideshowID][slideIndex].title);
        $("#" + slideshowID + " .slideshow-caption").html(this.slides[slideshowID][slideIndex].caption);
    },
    prevSlide: function(slideshowID) {
        if (this.currSlide[slideshowID] <= 0) {
            this.currSlide[slideshowID] = this.slides[slideshowID].length - 1;
        } else this.currSlide[slideshowID]--;
        this.goToSlide(slideshowID, this.currSlide[slideshowID]);
    },
    nextSlide: function(slideshowID) {
        if (this.currSlide[slideshowID] >= this.slides[slideshowID].length - 1) {
            this.currSlide[slideshowID] = 0;
        } else this.currSlide[slideshowID]++;
        this.goToSlide(slideshowID, this.currSlide[slideshowID]);
    },
    currPos: function(slideshowID) {
        var windowWidth = $(window).width(),
            offset = 0,
            currSlideWidth = $("#" + this.slides[slideshowID][this.currSlide[slideshowID]].id).outerWidth(true);
        $.each(this.slides[slideshowID], function(i, slide) {
            if (i < slideshowCentral.currSlide[slideshowID]) {
                offset += $("#" + slide.id).outerWidth(true);
            } else return false;
        });
        return ( ( windowWidth - currSlideWidth ) / 2 ) - offset;
    },
    init: function(slideshowID, slideArray) {
        var initMU = '' +
                '<div class="slideshow-wrapper-wrapper"><div class="slideshow-wrapper"></div></div>' +
                '<div class="slideshow-controls">' +
                    '<div class="slideshow-btn-wrapper">' +
                        '<button class="slideshow-prev-btn" onclick="slideshowCentral.prevSlide(\'' + slideshowID + '\')"></button>' +
                    '</div>' +
                    '<div class="slideshow-inner-controls">' +
                        '<div class="slideshow-buttons"></div>' +
                        '<div class="slideshow-title"></div>' +
                        '<div class="slideshow-caption"></div>' +
                    '</div>' +
                    '<div class="slideshow-btn-wrapper">' +
                        '<button class="slideshow-next-btn" onclick="slideshowCentral.nextSlide(\'' + slideshowID + '\')"></button>' +
                    '</div>' +
                '</div>',
            slideStart = "<div class='slideshow-slide' id='",
            slideMiddle = "' onclick='slideshowCentral.goToSlide(\"",
            slideEnd = ");'></div>",
            buttonStart = "<button class='slideshow-button' onclick='slideshowCentral.goToSlide(\"",
            buttonEnd = ");'></button>";
        $(document).ready(function() {
            slideshowCentral.currSlide[slideshowID] = 0;
            slideshowCentral.slides[slideshowID] = slideArray;
            $("#" + slideshowID).append(initMU);
            $.each(slideArray, function(i, slide) {
                $("#" + slideshowID + " .slideshow-wrapper").append(slideStart + slide.id + slideMiddle + slideshowID + "\"," + i + slideEnd);
                $("#" + slideshowID + " .slideshow-buttons").append(buttonStart + slideshowID + "\"," + i + buttonEnd);
            });
            $("#" + slideshowID + " .slideshow-wrapper").css("left", slideshowCentral.currPos(slideshowID) + "px");
            $($("#" + slideshowID + " .slideshow-slide")[0]).addClass("current-slide");
            $($("#" + slideshowID + " .slideshow-button")[0]).addClass("current-button");
            $("#" + slideshowID + " .slideshow-title").append(slideArray[0].title);
            $("#" + slideshowID + " .slideshow-caption").append(slideArray[0].caption);
        });
        $(window).resize(function() {
            slideshowCentral.goToSlide(slideshowID, slideshowCentral.currSlide[slideshowID]);
        });
    }
}
